// @ts-nocheck

export type StoriesListOrdering =
  typeof StoriesListOrdering[keyof typeof StoriesListOrdering];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StoriesListOrdering = {
  "-created_at": "-created_at",
  "-last_read_at": "-last_read_at",
  "-title": "-title",
  created_at: "created_at",
  last_read_at: "last_read_at",
  title: "title",
} as const;
